import React, { Component } from 'react';
import { Button } from 'antd';
import { skipBind } from '../../api'
import { SET_USER_INFO } from '../../App.action'

import './index.less'

class PhoneBind extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
    }

    skipBind = async () => {
        await skipBind()
        let userInfo = this.props.userInfo
        userInfo.bindSkipped = true
        this.props.dispatch({
            type: SET_USER_INFO,
            userInfo
        })
        window.location.href = "/account";
        this.props.onSkipped && this.props.onSkipped()
    }

    render() {
      const userInfo = this.props.userInfo;
        return <div className="qr qr-bind">
            <div>
                <div>登录提示</div>
                {userInfo && !userInfo.phoneNo && <div>您未绑定手机号码！</div>}
                {userInfo && !userInfo.aliUserId && <div>您未绑定支付宝，绑定后可直接扫码登录！</div>}
            </div>
            <div className="skip-bind">
                <Button type="primary" onClick={this.skipBind}>前去绑定</Button>
            </div>
        </div>
    }
}

export default PhoneBind



// WEBPACK FOOTER //
// ./src/components/PhoneBind/index.jsx